import { type ApplicationState, useApplicationState } from '@lib/state';

const selectActiveStore = (s: ApplicationState) => s.schedule.store;
export const useActiveStore = () => useApplicationState(selectActiveStore);

export default useActiveStore;
